
export default class Card {

  public title: string;
  public subTitle: string;
  public image?: string;
  public htmlCode?: JSX.Element;
  public linkToRedirect?: string;
  public imageWidth?: string;

  constructor(title: string, subTitle: string, image?: string, htmlCode?: JSX.Element, linkToRedirect?: string, imageWidth?: string) {
    this.title = title;
    this.subTitle = subTitle;
    this.image = image;
    this.htmlCode = htmlCode;
    this.linkToRedirect = linkToRedirect;
    this.imageWidth = imageWidth;
  }

}
